import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getData } from "../newApis/dotNetApiMethods";

export const getInvestmentCurrencies = async () => {
  const { data } = await getData(`${ajaxEndpoints.INVESTMENT_CURRENCIES}`);
  return data;
};

export default function useInvestmentCurrencies() {
  return useQuery("investmentCurrencies", getInvestmentCurrencies, {
    refetchOnWindowFocus: false, // Refetch on window focus
  });
}
